import { SectionItem, type SectionItemProps } from 'settle-ui/components/SectionItem/SectionItem'

export type AuthActionsRowProps = Omit<SectionItemProps, 'gap' | 'spacing' | 'fullWidth' | 'horizontalGutter'>

/** Action-button row at the foot of an AuthCard; the 12px gap is fixed and not settable by prop. */
export const AuthActionsRow: Settle.FC<AuthActionsRowProps> = ({ direction = 'row', ...props }) => (
  <SectionItem {...props} fullWidth={true} horizontalGutter="none" direction={direction} sx={{ gap: 1.5 }} />
)
